import { create } from 'zustand';

interface CloseSingleSecurityDrawerStore {
    isDrawerClosed: boolean;
    setIsDrawerClosed: (open: boolean) => void;
}

// Create the Zustand store with types
const CloseSingleSecurityDrawerStore = create<CloseSingleSecurityDrawerStore>((set) => ({
    isDrawerClosed: false,
    setIsDrawerClosed: (open: boolean) => set({ isDrawerClosed: open }),
}));

export default CloseSingleSecurityDrawerStore;
